function SixthPage() {
  return (
    <div className="mt-32">
      <img
        src="/images/bg-gradient-blue.png"
        alt=""
        className="hidden lg:block absolute -z-10 right-0  top-[595%] above-1100:top-[480%] xl:top-[310%] 2xl:top-[440%]"
      />
      <div id="container" className=" w-[80%] mx-auto mt-12">
        <div className="flex justify-between flex-row">
          <div className="text-white flex flex-col justify-center items-center gap-6 max-w-[40rem]  mx-auto text-center lg:text-start lg:w-[50%]">
            <h1 className="text-4xl sm:text-6xl font-extrabold sm:leading-tight">
              Take your first step into safe, secure crypto investing
            </h1>
            <p className="text-gray-500">
              Start your crypto journey with confidence. 
              Our platform puts your safety first with bank-level security and real-time support.
            </p>
            <button className="lg:self-start text-white py-4 px-6 bg-gradient-to-tr from-[#933FFE] to-[#18C8FF] rounded-lg transition-all cursor-pointer hover:translate-y-2">
              Get Started
            </button>
          </div>
          <div className="w-[50%]  hidden lg:block">
            <img
              src="/images/suitcase.png"
              alt=""
              className="relative lg:left-[0%] xl:left-[0%] top-[5%]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SixthPage;
